import React from 'react';
import './tooltip.scss';

export default function Tooltip({ data , type }) {

  return (
    <div
      className={`tooltip ${type}`}
      style={{
        left: data.x - 10 ,
        top: data.y ,
        border: `2px solid ${data.color ? data.color : "transparent" }`,
        opacity: data.color ? 1 : 0 
      }}>
      {data && data.city && type === "geography" &&
        <p>
          <span className="code">{data.label}</span><br/>
          <span style={{ color: data.color }}>{data.pathologyName}</span><br/>
          <span>{data.city}</span><br/>
        </p>
      }
       {data && type === "genealogy" &&
        <p>
          <span className="code">{data.label}</span><br/>
          <span style={{ color: data.color }}>{data.pathologyName}</span><br/>
        </p>
      }
    </div>
  )
}
